import React, { Fragment } from 'react';
import moment from 'moment';

import {
    Typography,
    Box,
    Grid,
    colors,
    makeStyles,
    Chip,
    Avatar
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    labelvalue: {
        padding: 7
    },
    instrumenticon: {
        padding: 1,
        width: 120,
        height: 120
    },
    chipgreen: {
        backgroundColor: colors.green[400],
        width: 85,
        margin: 4
    },
    chipblue: {
        backgroundColor: colors.green[400],
        width: 85,
        margin: 4
    },
    chipred: {
        backgroundColor: colors.orange[600],
        width: 85,
        margin: 4,
        color: "#ffffff"
    },
    chipyellow: {
        backgroundColor: colors.yellow[900],
        width: 85,
        margin: 4,
        color: "#ffffff"
    },
    chipbluelarge: {
        backgroundColor: colors.blue[400],
        width: 160,
    },
    chipredlarge: {
        backgroundColor: colors.red[600],
        width: 160,
        color: "#ffffff"
    },

}));


const INST06 = ({ instrument, message, event, instruments, alarm, device, schedules, commands, sendCommands }) => {

    const classes = useStyles();

    const getStateImage = (instrument, message, alarm) => {
        var alarmedin = false;
        var alarmedout = false;
        instrument.inputfields.map((infield) => {
            message.inputs.map((field) => {
                if (field.order === infield.fieldindex) {
                    if (!alarmedin && isAlarmedField(field, alarm)) {
                        alarmedin = true;
                    }
                }
            });
        });
        instrument.outputfields.map((infield) => {
            message.inputs.map((field) => {
                if (field.order === infield.fieldindex) {
                    if (!alarmedout && isAlarmedField(field, alarm)) {
                        alarmedout = true;
                    }
                }
            });
        });
        if (alarmedin && alarmedout) {
            return '/static/images/instruments/bomba2.gif'
        } else if (alarmedin) {
            return '/static/images/instruments/bomba2.gif';
        } else if (alarmedout) {
            return '/static/images/instruments/bomba2.gif';
        } else {
            return '/static/images/instruments/bomba0.jpg'
        }
    }

    const isAlarmedField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.order == field.order && fail.type === 'fail') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    const isWarningField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.id == field._id && fail.type === 'warn') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    return (
        <Fragment>
            <Box padding={1} margin={instrument.border} border={instrument.border} borderRadius={instrument.radius}
                borderColor={colors.grey[300]}>

                <Typography color="textSecondary" variant="h5" className={classes.labelvalue}>
                    <b>{instrument.label}</b>
                </Typography>

                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                >

                    <Grid item xs="auto" key={instrument._id} >

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}  >
                                                {infield.label}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">
                                            {isAlarmedField(field, alarm) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={(event.data[field.order] === 1) ? infield.on : infield.off} />

                                            ) : (
                                                (isWarningField(field, alarm)) ? (
                                                    <Chip className={classes.chipyellow}
                                                        size="small"
                                                        label={(event.data[field.order] === 1) ? infield.on : infield.off} />

                                                ) : (
                                                    <Chip className={classes.chipblue}
                                                        size="small"
                                                        label={(event.data[field.order] === 1) ? infield.on : infield.off} />

                                                )
                                            )}
                                        </Grid>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field) => (
                                (field.order === infield.fieldindex && (index >= instrument.inputfields.length)) ? (
                                    <Grid item xs="auto">
                                        <div>&nbsp;</div>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                    </Grid>

                    <Grid item xs="auto">
                        <Avatar className={classes.instrumenticon} variant="square"
                            src={getStateImage(instrument, message, alarm)}>
                        </Avatar>
                    </Grid>


                    {schedules.map((schedule) => (
                        <Grid item xs="auto">
                            <Box >

                                <Grid item xs="auto" spacing={1} >

                                    <Grid
                                        container
                                        spacing={1}
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}  >
                                                Último Acionamento
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">
                                            <Chip className={classes.chipbluelarge}
                                                size="small"
                                                label={moment(schedule.lastInactivityCheck).format('DD/MM/YYYY HH:mm:ss')} />
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={1}
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}  >
                                                Próximo acionamento
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">

                                            {(moment().isBefore(moment(schedule.nextInactivityCheck))) ?
                                                (
                                                    <Chip className={classes.chipbluelarge}
                                                        size="small"
                                                        label={moment(schedule.nextInactivityCheck).format('DD/MM/YYYY HH:mm:ss')} />
                                                ) : (
                                                    <Chip className={classes.chipredlarge}
                                                        size="small"
                                                        label={moment(schedule.nextInactivityCheck).format('DD/MM/YYYY HH:mm:ss')} />

                                                )}

                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Box>

                        </Grid>

                    ))}

                </Grid>

            </Box>
        </Fragment >
    );

}

export default INST06;